import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { NgProgressRef, NgProgress } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { KaspiSettingsUpload } from 'src/app/models';
import { ApiKaspiSettingsService, NotificationService, ValidatorsService } from 'src/app/services';
import { KaspiSettingsValidator } from '../kaspi-settings.validator';

@Component({
  selector: 'app-upload',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.css']
})
export class UploadComponent implements OnInit {

  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  errorMessages: any;
  settings: KaspiSettingsUpload;
  loading: boolean;

  uploadForm: UntypedFormGroup = this.fb.group({
    id:         [null],
    merchantId: [null, this.validator.merchantId],
    apikey:     [null, this.validator.apikey],
    company:    [null, this.validator.company],
  });


  constructor(
    public ngProgress: NgProgress,
    private fb: UntypedFormBuilder,
    private apiKaspiSettings: ApiKaspiSettingsService,
    private notification: NotificationService,
    private validator: KaspiSettingsValidator,
    private validatorService: ValidatorsService,
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');
    this.errorMessages = this.validator.errorMessages;
    
    this.onEdit();
  }

  ngOnDestroy(): void {

    this.subscriptions.unsubscribe();
  }


  /**
   * 
   */
  initForm(): void {

    if(this.settings != null){

      this.uploadForm.setValue({
        id:         this.settings.id ? this.settings.id : null,
        merchantId: this.settings.merchantId,
        apikey:     this.settings.apikey,
        company:    this.settings.company,
      });
    }
  }


  /**
   * 
   */
  onEdit(): void {

    this.progressRef.start();
    
    this.subscriptions.add(
      this.apiKaspiSettings.uploadInfo().subscribe((response: any) => { console.log('[RESPONSE] getCredentialData: ', response);

        if(response != null){

          this.settings = response.result;

          this.initForm();
        }

        this.progressRef.complete();
      },
      error => { 
        this.progressRef.complete(); 
      })
    );
  }


  /**
   * 
   */
  onSave(): void {

    this.progressRef.start();
    this.loading = true;

    this.subscriptions.add(
      this.apiKaspiSettings.uploadSave(this.uploadForm.value).subscribe((response: any) => { console.log('[RESPONSE] saveCredentialData: ', response);

        if(response != null){

          this.onEdit();
          this.notification.show('success', 'Данные успешно сохранены!');
        }

        this.progressRef.complete();
        this.loading = false;
      },
      error => { 
        this.progressRef.complete(); 
        this.loading = false;
      })
    );
  }


  /**
   * 
   * @param field 
   * @param type 
   */
  validation(field: string, type: string): boolean {

    return this.validatorService.validation(this.uploadForm.get(field), type);
  }


  /**
   * 
   * @param field 
   */
  checkingFieldStatus(field: string): string {

    return this.validatorService.checkingFieldStatus(this.uploadForm.get(field));
  }

}
